import { Injectable } from '@angular/core';

import { Observable, map, debounceTime, startWith } from 'rxjs';
import { combineLatest, distinctUntilChanged, scan } from 'rxjs/operators'; //import combineLatest musi być z 'rxjs/operators' ponieważ bezpośrednio z rxjs to jest 'inna' funkcja

import { IScrollService } from '../../interfaces/IScrollService';

/**
 * Help struct.
 */
class Data {
    public ratio!: number;
    public numObjects!: number;
}


/**
 * Scroll service.
 */
@Injectable()
export class ScrollService implements IScrollService {

    /**
     * Debounce time of scrolling.
     */
    private readonly DEBOUNCE_TIME: number = 0;


    /**
     * Scroll speed in percent. 100% means that scrolling will be very fast. Must be greater than 25.
     */
    private readonly SCROLL_SPEED_IN_PERCENT: number = 25;


    /**
     * Service constructor.
     */
    constructor() { }


    /**
     *
     */
    public getObjectsToShow$<T>(
        objects$: Observable<T[]>,
        scroll$: Observable<Event>,
        show: number,
        startIndex?: number
    ): Observable<T[]> {

        const initial = startIndex || 0;
        // if (startIndex && startIndexFieldName) {
        //     initial = objects$.findIndex(i => i[startIndexFieldName] === startIndex);
        // }

        const start$ = this.getStartIndex$(objects$, scroll$, show, initial);

        const sliced$ = objects$.pipe(combineLatest(start$, (objects, start) => {
            const end = start + show;
            return objects.slice(start, end);
        }));

        return sliced$;
    }


    /**
     *
     */
    public getStartIndex$<T>(
        objects$: Observable<T[]>,
        scroll$: Observable<Event>,
        show: number,
        initial: number = 0
    ): Observable<number> {

        const ratio$ = scroll$.pipe(
            map(event => {
                const target = event.target as HTMLDivElement;
                const factor = target.scrollHeight - target.offsetHeight;
                const ratio = (factor === 0) ? 0 : target.scrollTop / factor;
                return ratio;
            }),
            startWith(0),
            debounceTime(this.DEBOUNCE_TIME));

        const data$ = ratio$.pipe(combineLatest(objects$, (ratio, objects) =>
            <Data>{ ratio: ratio, numObjects: objects.length }));

        const start$ = data$
            .pipe(scan((acc, data) => {

                const hi = 1.0 - (this.SCROLL_SPEED_IN_PERCENT / 100.0);
                const lo = 0.0 + (this.SCROLL_SPEED_IN_PERCENT / 100.0);

                if (show > data.numObjects) {
                    return 0;
                } else if (data.ratio >= hi) {
                    return Math.min(data.numObjects - show, acc + 1);
                } else if (data.ratio <= lo) {
                    return Math.max(0.0, acc - 1);
                } else {
                    return acc;
                }

            }, initial),
            distinctUntilChanged());

        return start$;
    }
}
